/**
 * CartMain - cart page main container; syncs line items with the cart service.
 * Custom element: <cart-main>
 *
 * Attributes (from $info):
 *   section-id  String  cart-main
 *
 * Refs:
 *   [data-ref="updatingCart"]  (required)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import "./component-LoadingSpinner.js";
import { ThemeComponent, cart } from "./theme.js";
import { queryString, axios } from "./vendor.js";
class CartMain extends ThemeComponent {
  init() {
    this.$subscribe(cart.onChangeByInteraction, async () => {
      this.updateItemsMarkup(), document.body.classList.add("cart-has-changed-since-load");
    });
  }
  setLoading(isLoading = !1) {
    isLoading ? this.updatingCart.classList.add("is-active") : this.updatingCart.classList.remove("is-active");
  }
  async updateItemsMarkup() {
    this.setLoading(!0);
    const {
        url: pageUrl,
        query: query
      } = queryString.parseUrl(window.location.href, {
        decode: !1
      }),
      sectionUrl = queryString.stringifyUrl({
        url: pageUrl,
        query: {
          ...query,
          sections: `${this.sectionId}`
        }
      }, {
        arrayFormat: "none",
        encode: !1
      }),
      response = await axios.get(sectionUrl),
      parsedContainer = document.createElement("div");
    parsedContainer.innerHTML = response.data[`${this.sectionId}`];
    const newContainer = parsedContainer.querySelector(".cart-main__container"),
      existingContainer = this.querySelector(".cart-main__container");
    newContainer && existingContainer && (existingContainer.outerHTML = newContainer.outerHTML), this.setLoading(!1);
  }
}
setFunctionName(CartMain, "CartMain");
const propertyTypes = {
  String
};
CartMain.prototype.$name = "CartMain";
CartMain.prototype.$info = JSON.parse('{"name":"CartMain","meta":{"isLegacy":false,"selector":"cart-main"},"props":[{"attr":"section-id","default":"cart-main","reflectAttr":false,"propertyKey":"sectionId","propertyType":"String","propertyTypeName":"String","propertyTsTypeName":"string"}],"refs":[{"selector":"[data-ref=\\"updatingCart\\"]","required":true,"propertyKey":"updatingCart","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"LoadingSpinner"}]}');
CartMain.prototype.$info.component = CartMain;
for (const prop of CartMain.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("Cart/CartMain.ts", {
  CartMain: CartMain
}, void 0);